"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
const inputClasses = "w-full px-4 py-3 rounded-lg border border-sand-dark bg-sand-light focus:outline-none focus:ring-2 focus:ring-terracotta focus:border-transparent transition-all";
type BaseProps = {
  id: string;
  name: string;
  label: string;
  required?: boolean;
  requiredLabel?: string;
  icon?: React.ReactNode;
};
type InputFieldProps = BaseProps & {
  type: "text" | "email" | "tel";
  value: string;
  placeholder?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};
type TextareaFieldProps = BaseProps & {
  value: string;
  placeholder?: string;
  rows?: number;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
};
function FieldLabel(t0) {
  const $ = _c(7);
  const {
    htmlFor,
    label,
    required,
    requiredLabel
  } = t0;
  let t1;
  if ($[0] !== required || $[1] !== requiredLabel) {
    t1 = required && requiredLabel && <span className="text-terracotta">{requiredLabel}</span>;
    $[0] = required;
    $[1] = requiredLabel;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== htmlFor || $[4] !== label || $[5] !== t1) {
    t2 = <label htmlFor={htmlFor} className="block text-sm font-medium text-forest-green mb-2">{label}{" "}{t1}</label>;
    $[3] = htmlFor;
    $[4] = label;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
export function InputField(t0) {
  const $ = _c(22);
  const {
    id,
    name,
    label,
    type,
    value,
    onChange,
    placeholder,
    required,
    requiredLabel,
    icon
  } = t0;
  let t1;
  if ($[0] !== id || $[1] !== label || $[2] !== required || $[3] !== requiredLabel) {
    t1 = <FieldLabel htmlFor={id} label={label} required={required} requiredLabel={requiredLabel} />;
    $[0] = id;
    $[1] = label;
    $[2] = required;
    $[3] = requiredLabel;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== icon) {
    t2 = icon && <span className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-wood-natural">{icon}</span>;
    $[5] = icon;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = icon ? `${inputClasses} pl-12` : inputClasses;
  let t4;
  if ($[7] !== id || $[8] !== name || $[9] !== onChange || $[10] !== placeholder || $[11] !== required || $[12] !== t3 || $[13] !== type || $[14] !== value) {
    t4 = <input type={type} id={id} name={name} value={value} onChange={onChange} required={required} className={t3} placeholder={placeholder} />;
    $[7] = id;
    $[8] = name;
    $[9] = onChange;
    $[10] = placeholder;
    $[11] = required;
    $[12] = t3;
    $[13] = type;
    $[14] = value;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t2 || $[17] !== t4) {
    t5 = <div className="relative">{t2}{t4}</div>;
    $[16] = t2;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t1 || $[20] !== t5) {
    t6 = <div className="relative">{t1}{t5}</div>;
    $[19] = t1;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
}
export function TextareaField(t0) {
  const $ = _c(16);
  const {
    id,
    name,
    label,
    value,
    onChange,
    placeholder,
    required,
    requiredLabel,
    rows: t1
  } = t0;
  const rows = t1 === undefined ? 6 : t1;
  let t2;
  if ($[0] !== id || $[1] !== label || $[2] !== required || $[3] !== requiredLabel) {
    t2 = <FieldLabel htmlFor={id} label={label} required={required} requiredLabel={requiredLabel} />;
    $[0] = id;
    $[1] = label;
    $[2] = required;
    $[3] = requiredLabel;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== id || $[6] !== name || $[7] !== onChange || $[8] !== placeholder || $[9] !== required || $[10] !== rows || $[11] !== value) {
    t3 = <textarea id={id} name={name} value={value} onChange={onChange} required={required} rows={rows} className={`${inputClasses} resize-none`} placeholder={placeholder} />;
    $[5] = id;
    $[6] = name;
    $[7] = onChange;
    $[8] = placeholder;
    $[9] = required;
    $[10] = rows;
    $[11] = value;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t2 || $[14] !== t3) {
    t4 = <div>{t2}{t3}</div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}